import { ProductVisibility } from "../../../classes/interfaces";

export type StoreChannel = "menu" | "store";

export function isProductVisibleInChannel(
  visibility: ProductVisibility | null | undefined,
  channel: StoreChannel
): boolean {
  return !visibility || visibility === "all" || visibility === channel;
}

/**
 * Fonte unica de "este canal vende?". /menu/:suffix e cardapio-vitrine: o
 * cliente navega e abre os detalhes, mas nao monta sacola nem chega ao
 * checkout. /store (e as rotas de mesa, que tambem sao canal "store") vendem.
 */
export function canAddToCart(channel: StoreChannel): boolean {
  return channel === "store";
}
